import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import {
  Calendar,
  ReferenceContainer,
  ItemContainer,
  GreenCircle,
  YellowCircle,
  RedCircle,
  ReferenceText,
  WhiteCircle,
  EmptyMonthMessage,
} from "./Calendar.styles.js";
import { addAvailabilityColor, getDates } from "./helpers.js";
import { createUTCDate } from "../../../../../helpers/dates.js";

const ExperienceCalendar = ({
  availability = [],
  onChangeMonth,
  onClickOnDate,
  onCalendarOpen,
  isLoading,
  initialDate,
  defaultDate,
  capacityUsage,
}) => {
  const { t } = useTranslation("experiences");
  const filteredAvailability = availability.filter(({ date }) => {
    const today = createUTCDate();
    return date.isSameOrAfter(today, "day");
  });

  const mappedAvailability = filteredAvailability.map((availabilityItem) => {
    return {
      ...availabilityItem,
      date: availabilityItem.date.toDate(),
    };
  });

  const sellableDates = getDates(mappedAvailability, capacityUsage);

  // `GET /experiences/availability/next/:id` no mira ocupación ni bloqueos, así
  // que puede abrir el calendario en un mes donde ya no queda nada vendible.
  // Sin este aviso el mes queda mudo y sin explicación.
  const isEmptyMonth = !isLoading && isEmpty(sellableDates);

  const RenderReference = () => {
    return (
      <>
        {isEmptyMonth && (
          <EmptyMonthMessage>
            {t("availability.noAvailableDatesInMonth")}
          </EmptyMonthMessage>
        )}
        <ReferenceContainer>
          <ItemContainer>
            <GreenCircle />
            <ReferenceText>{t("availability.availability")}</ReferenceText>
          </ItemContainer>

          <ItemContainer>
            <YellowCircle />
            <ReferenceText>{t("availability.lowAvailability")}</ReferenceText>
          </ItemContainer>

          <ItemContainer>
            <RedCircle />
            <ReferenceText>{t("availability.unavailable")}</ReferenceText>
          </ItemContainer>
          <ItemContainer>
            <WhiteCircle />
            <ReferenceText>{t("availability.withoutActivity")}</ReferenceText>
          </ItemContainer>
        </ReferenceContainer>
      </>
    );
  };

  return (
    <Calendar
      placeholder={t("selectDates")}
      availableDates={sellableDates}
      onClickOnDate={onClickOnDate}
      onChangeMonth={onChangeMonth}
      highlightDates={addAvailabilityColor(mappedAvailability, capacityUsage)}
      renderReference={<RenderReference />}
      isLoading={isLoading}
      onCalendarOpen={onCalendarOpen}
      initialDate={initialDate}
      defaultDate={defaultDate}
      inline={true}
    />
  );
};

ExperienceCalendar.propTypes = {
  availability: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.object.isRequired,
      // Puede ser null: un día cuyos turnos no tienen porcentaje calculable
      // —una regla con máximo 0— no tiene ocupación que promediar.
      occupiedPercentage: PropTypes.number,
    })
  ).isRequired,
  onClickOnDate: PropTypes.func.isRequired,
  onChangeMonth: PropTypes.func.isRequired,
  initialDate: PropTypes.instanceOf(Date()),
  capacityUsage: PropTypes.shape({
    mode: PropTypes.string,
    units: PropTypes.number,
  }),
};

export default ExperienceCalendar;
